import { List, Map } from 'immutable';
import { fundingSearchOffer, fundingSearchMatch, fundingSearchOffers } from './types';
import { normalizeIds, normalizeModelList } from '../../utils/Normalizer';

export * from './actions';

const fundingSearchMatchOfferReducersObject = {
  [fundingSearchOffers.request]: (state, action) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['fundingSearchMatchOffers', 'network', 'loading'], true)
        .setIn(['fundingSearchMatchOffers', 'fundingSearchId'], action.fundingSearchId),
    ),
  [fundingSearchOffers.success]: (state, { fundingSearchId, response }) =>
    state.withMutations((currentState) =>
      response
        .reduce(
          (reduceState, { id, offers }) =>
            reduceState
              .mergeIn(['fundingSearchMatchOffers', 'ids'], normalizeIds(offers))
              .mergeIn(['fundingSearchMatchOffers', 'byId'], normalizeModelList(offers))
              .mergeIn(
                ['fundingSearchMatchOffers', 'groupByFundingMatchId'],
                Map({ [id]: normalizeIds(offers) }),
              ),
          currentState,
        )
        .setIn(['fundingSearchMatchOffers', 'fundingSearchId'], fundingSearchId)
        .setIn(['fundingSearchMatchOffers', 'network', 'loading'], false)
        .setIn(['fundingSearchMatchOffers', 'network', 'error'], false),
    ),
  [fundingSearchOffers.failure]: (state, action) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['fundingSearchMatchOffers', 'network', 'loading'], false)
        .setIn(['fundingSearchMatchOffers', 'network', 'error'], action.error),
    ),

  [fundingSearchOffer.request]: (state, action) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['fundingSearchMatchOffer', 'match', 'network', 'id'], action.matchId)
        .setIn(['fundingSearchMatchOffer', 'network', 'error'], false)
        .setIn(['fundingSearchMatchOffer', 'network', 'loading'], true)
        .setIn(['fundingSearchMatchOffer', 'network', 'id'], action.offerId),
    ),
  [fundingSearchOffer.success]: (state, { response }) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['fundingSearchMatchOffer', 'ids', response.id], response)
        .setIn(['fundingSearchMatchOffer', 'network', 'error'], false)
        .setIn(['fundingSearchMatchOffer', 'network', 'loading'], false),
    ),
  [fundingSearchOffer.failure]: (state, action) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['fundingSearchMatchOffer', 'network', 'loading'], false)
        .setIn(['fundingSearchMatchOffer', 'network', 'error'], action.error),
    ),
  [fundingSearchMatch.request]: (state, action) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['fundingSearchMatchOffer', 'match', 'network', 'id'], action.matchId)
        .setIn(['fundingSearchMatchOffer', 'match', 'network', 'error'], false)
        .setIn(['fundingSearchMatchOffer', 'match', 'network', 'loading'], true),
    ),
  [fundingSearchMatch.success]: (state, { matchId, response }) =>
    state.withMutations((currentState) => {
      const historyIds = currentState.getIn(
        ['offersHistory', 'groupByFundingMatchId', String(matchId)],
        List(),
      );

      historyIds.map((id) =>
        currentState.setIn(['offersHistory', 'byId', id, 'lender'], response.lender),
      );

      currentState
        .setIn(['fundingSearchMatchOffer', 'ids', response.offer?.id, 'lender'], response.lender)
        .setIn(['fundingSearchMatchOffer', 'match', 'network', 'error'], false)
        .setIn(['fundingSearchMatchOffer', 'match', 'network', 'loading'], false);
    }),
  [fundingSearchMatch.failure]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['fundingSearchMatchOffer', 'match', 'network', 'error'], true)
        .setIn(['fundingSearchMatchOffer', 'match', 'network', 'loading'], false),
    ),
};

export default fundingSearchMatchOfferReducersObject;
